import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { MDash } from 'ui-components/components/mdash';
import { IntlUnitFormattingService } from '../../../../../../services/intl-unit-formatting-services/intl-unit-formatting-service';

import { messages } from '../../messages';

const WeightCell = ({ sellerDefaultWeightUnit, value }) => {
  if (value === 0) return <MDash />;

  return IntlUnitFormattingService.formatWeight(value, sellerDefaultWeightUnit);
};

export const createWeightColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'weight',
  Header: <FormattedMessage {...messages.weightColumnHeader} />,
  Cell: WeightCell,
  width: 1,
  minWidth: 100,
});
